export const DividingLineIcon = () => (
  <svg
    width="331"
    height="8"
    viewBox="0 0 331 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <line y1="3.5" x2="140" y2="3.5" stroke="#DADADA" strokeDasharray="2 2" />
    <line
      x1="191"
      y1="3.5"
      x2="331"
      y2="3.5"
      stroke="#DADADA"
      strokeDasharray="2 2"
    />
    <circle cx="166" cy="4" r="3.5" fill="#FFE8DA" stroke="#FFBF99" />
  </svg>
);